<template>
  <div v-if="tourIsEnabled">
    <el-dialog
      :visible.sync="showDashboardTourDialog"
      :width="modalWidth"
      :before-close="handleClose"
    >
      <div class="w-full flex flex-col items-center px-7 pb-7">
        <!-- <dashboard-tour-rocket /> -->
        <div
          class="w-40 h-40 border rounded-full overflow-hidden shadow mb-8"
          :class="{ rotation: tenantIsTorus }"
        >
          <lottie-animation
            :animation-data="animationData"
            :auto-play="true"
            :loop="true"
            :speed="1"
            ref="anim"
          />
        </div>
        <h4 class="text-fg-muted font-normal text-3xl mb-2">
          Hi {{ user.firstName }},👋
        </h4>
        <p class="text-3xl text-black-10 font-bold mb-5 capitalize">
          Welcome to {{ tenantName }}
        </p>
        <p class="text-base font-normal text-fg-muted text-center break-normal">
          We're thrilled to have you on board. Get ready to explore a world of
          endless possibilities and simplify your business tasks like never
          before.
        </p>
        <span slot="footer" class="dialog-footer w-full mt-10">
          <el-button
            class="w-full bg-primary text-white rounded-lg py-4"
            @click="beginDashboardTour"
            >Get Started</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue'
import OvalTourRocket from '@/assets/lotties/ovalDashboardTourRocket.json'
import TorusTourRocket from '@/assets/lotties/torusDashboardTourRocket.json'
import tmaTourRocket from '@/assets/lotties/tmaDashboardTourRocket.json'
import mixin from '@/mixins/tenant.js'
import tenantIsTorus from '@/mixins/app.js'
import tourMixins from '@/mixins/appTourApi.js'
import breakpoints from '@/utils/breakpoints.js'
export default {
  components: {
    LottieAnimation
  },
  mixins: [mixin, tourMixins, tenantIsTorus],
  data () {
    return {
      showDashboardTourDialog: false,
      OvalTourRocket,
      TorusTourRocket,
      tmaTourRocket
    }
  },
  methods: {
    beginDashboardTour () {
      this.showDashboardTourDialog = false
      this.$emit('startDashboardTour')
    },
    handleClose (done) {
      done()
      this.$store.dispatch('appTour/updateTourStatus', { dashboard: true })
    },
    async startTourForANewUser () {
      await this.fetchAllTours()
      if (this.isANewUser) {
        this.showDashboardTourDialog = true
      }
    }
  },
  computed: {
    animationData () {
      const activeTenant = process.env.VUE_APP_TENANT_NAME
      const rockets = {
        oval: this.OvalTourRocket,
        torus: this.TorusTourRocket,
        tma: this.tmaTourRocket
      }
      return rockets[activeTenant]
    },
    user () {
      return this.$store.state.auth.user
    },
    tenantName () {
      return process.env.VUE_APP_TENANT_NAME
    },
    isOnDevEnvironment () {
      return process.env.NODE_ENV !== 'production'
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    isANewUser () {
      return !this.$store.state.appTour.allTours.dashboard
    }
  },
  async mounted () {
    await this.startTourForANewUser()
  }
}
</script>

<style lang="scss" scoped>
.rotation {
  rotate: 40deg;
}
</style>
